import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

export const emptyShareholder = () => ({
  _uid: crypto.randomUUID(),
  fullName: '',
  idNumber: '',
  email: '',
  numberOfShares: '',
  shareValue: '',
});

const ShareholdersStep = ({ formData, updateArr, addRow, removeRow }) => (
  <div className="space-y-4" data-testid="step-shareholders">
    <h3 className="text-xl font-semibold mb-2 text-emerald-800">Shareholders</h3>
    {formData.shareholders.map((s, i) => (
      <Card key={s._uid || `sh-${i}`}>
        <CardHeader className="bg-blue-50">
          <div className="flex justify-between items-center">
            <CardTitle className="text-lg">Shareholder {i + 1}</CardTitle>
            {formData.shareholders.length > 1 && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => removeRow('shareholders', i)}
                className="text-red-600"
                data-testid={`remove-shareholder-${i}`}
              >
                Remove
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent className="pt-4 space-y-3">
          <div>
            <Label>Full Name *</Label>
            <Input
              value={s.fullName}
              data-testid={`shareholder-name-${i}`}
              onChange={(e) => updateArr('shareholders', i, 'fullName', e.target.value)}
            />
          </div>
          <div>
            <Label>ID / Passport Number</Label>
            <Input
              value={s.idNumber}
              onChange={(e) => updateArr('shareholders', i, 'idNumber', e.target.value)}
            />
          </div>
          <div>
            <Label>Email</Label>
            <Input
              type="email"
              value={s.email}
              onChange={(e) => updateArr('shareholders', i, 'email', e.target.value)}
            />
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            <div>
              <Label>Number of Shares *</Label>
              <Input
                type="number"
                value={s.numberOfShares}
                data-testid={`shareholder-shares-${i}`}
                onChange={(e) => updateArr('shareholders', i, 'numberOfShares', e.target.value)}
              />
            </div>
            <div>
              <Label>Value per Share (R)</Label>
              <Input
                type="number"
                value={s.shareValue}
                onChange={(e) => updateArr('shareholders', i, 'shareValue', e.target.value)}
              />
            </div>
          </div>
        </CardContent>
      </Card>
    ))}
    <Button
      onClick={() => addRow('shareholders', emptyShareholder)}
      variant="outline"
      className="w-full border-dashed border-2 border-blue-300 text-blue-600 hover:bg-blue-50"
      data-testid="add-shareholder-btn"
    >
      + Add Another Shareholder
    </Button>
  </div>
);

export default ShareholdersStep;
